module.exports = __webpack_public_path__ + "media/images/ukraine_dove-b9f00234cf153bae7c4e6bc5331a043e.png";